import { render, staticRenderFns } from "./coach-wxwork-card.vue?vue&type=template&id=6a81311f&scoped=true&"
import script from "./coach-wxwork-card.vue?vue&type=script&lang=js&"
export * from "./coach-wxwork-card.vue?vue&type=script&lang=js&"
import style0 from "./coach-wxwork-card.vue?vue&type=style&index=0&id=6a81311f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a81311f",
  null
  
)

export default component.exports